import { remoteConfig } from '@modules/firebase';
import { logger } from '@modules/logger';
import { type RemoteConfig, fetchAndActivate } from 'firebase/remote-config';
import { useEffect, useState } from 'react';

let remoteConfigSingleton: RemoteConfig;

/** Loads and initialises firebase remote config */
export function useRemoteConfig(): RemoteConfig | undefined {
  const [state, setState] = useState<RemoteConfig>(remoteConfigSingleton);

  useEffect(() => {
    if (state) {
      return;
    }

    remoteConfig.settings.minimumFetchIntervalMillis = 10000;

    fetchAndActivate(remoteConfig)
      .then(() => {
        setState(remoteConfig);
        remoteConfigSingleton = remoteConfig;
      })
      .catch((e) => logger.error('remoteConfig failed to activate', { error: e }));
  }, [state]);

  return state;
}
